/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, PropsWithChildren } from 'react';
import { useRouter } from 'next/router';
import { styled } from 'linaria/react';
import { Header } from '@widgets/header';
import { DesktopNavbar, MobileNavbar } from '@widgets/navbar';
import { SearchInputButton, SearchModalDesktop, SearchButton } from '@widgets/search';
import { SuggestTspModalDesktop, SuggestTspModalMobile } from '@widgets/tsp-suggest';
import { ToastContainer } from '@widgets/toasts';
import { Footer } from '@widgets/footer';
import { Mobile } from '@shared/lib/react';
import { useCurrentTspOnly } from '@shared/lib';
import { useIsMyMts } from '@shared/lib/utm';
interface CyberLayoutProps {
  withoutMobileNavbar?: boolean;
  withoutMobileSearchButton?: boolean;
  // technicalWorkStatus?: TechnicalWorkStatusType | null
}
export const CyberLayout: FC<PropsWithChildren<CyberLayoutProps>> = ({
  withoutMobileNavbar = false,
  withoutMobileSearchButton = false,
  children
}) => {
  const router = useRouter();
  const {
    isCurrentTspOnly
  } = useCurrentTspOnly();
  const isMyMts = useIsMyMts();

  // const isTechnicalWorkModalEnabled = technicalWorkStatus?.status

  // console.log(servicesForSearch)

  return <LayoutWrapper>
      <HeaderWrapper>
        <Header
      // widget={<TestWidget />}
      navbar={<DesktopNavbar renderSearchModal={({
        open,
        onClose,
        navbarRef
      }) => <SearchModalDesktop open={open} onClose={onClose} navbarRef={navbarRef} renderSuggestModal={({
        open,
        onClose
      }) => <SuggestTspModalDesktop open={open} onClose={onClose} />} />} />} searchButton={<SearchInputButton renderSuggestModal={({
        open,
        onClose
      }) => <SuggestTspModalMobile open={open} onClose={onClose} />} />} mobileSearchButton={!withoutMobileSearchButton && <SearchButton renderSuggestModal={({
        open,
        onClose
      }) => <SuggestTspModalMobile open={open} onClose={onClose} />} />} />
      </HeaderWrapper>
      <ContentWrapper>{children}</ContentWrapper>
      {!isCurrentTspOnly && <FooterWrapper>
          <Footer />
        </FooterWrapper>}
      {!withoutMobileNavbar && !isCurrentTspOnly && !isMyMts && <Mobile>
          <MobileNavbarWrapper>
            <MobileNavbar />
          </MobileNavbarWrapper>
        </Mobile>}
      <div id="modal-container">
        {/* {isTechnicalWorkModalEnabled && (
          <NoSSR>
          <ModalBannerTechinalWork title={technicalWorkStatus.title} description={technicalWorkStatus.description} />
          </NoSSR>
          )} */}
      </div>
      <ToastContainer />
    </LayoutWrapper>;
};
const LayoutWrapper = /*#__PURE__*/styled('div')({
  name: "LayoutWrapper",
  class: "lqv9leq",
  propsAsIs: false
});
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h1sk9rfo",
  propsAsIs: false
});
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1sl3907",
  propsAsIs: false
});
const FooterWrapper = /*#__PURE__*/styled('div')({
  name: "FooterWrapper",
  class: "fiylt5q",
  propsAsIs: false
});
const MobileNavbarWrapper = /*#__PURE__*/styled('div')({
  name: "MobileNavbarWrapper",
  class: "m162wmrp",
  propsAsIs: false
});

require("./CyberLayout.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./CyberLayout.tsx");